export default __webpack_public_path__ + "static/media/calendar-disabled.acb2980c.svg";